import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import Container from '../components/containers/Container'
import axios from 'axios';
import REACT_APP_API_BASE_URL from '../index.js';

const RegisterView = () => {
  const { configurations } = useContext(ConfigurationContext);
  const { 
    type,
    getAnswers,
    configurationId,
  } = useContext(UserContext);
  const [state, setState] = useState({ error: false, redirect: false });
  if(!configurations) return <Redirect to='/'/>;
  if(state.redirect) return <Redirect to='/confirmation'/>;

  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const questions      = currentProduct.fields;

  const registration  = configurations.items.find( item => item.fordonstyp === 'registration' );

  const content  = configurations.items.find( item => item.fordonstyp === 'mail' );
  
  function handleSubmit(e) {
    e.preventDefault();

    const name  = document.getElementById('first_name').value + ' ' + document.getElementById('last_name').value;
    const tel   = document.getElementById('tel').value;
    const org   = document.getElementById('org').value;
    const mail  = document.getElementById('mail').value;

    let formData = {};
    let answers = [];

    getAnswers().map( (a, i) => {
      const newPropsObj = {
        id : a.id,
        answer : a.answer
      };
      answers[i] = newPropsObj;
    })

    formData.questions         = questions;
    formData.answers           = answers;
    formData.userdata     = { 
      name: name,
      tel: tel,
      org: org,
      mail: mail };
    formData.content           = content;

    axios
    .post( REACT_APP_API_BASE_URL + '/send-confirmation', formData )
    .then(response => {
      if(response.status === 200) {
        setState( { ...state, redirect: true } )
      } else {
        setState( { ...state, error: true } )
      }
    })
    .catch( err => {
      setState( { ...state, error: true } )
    });
  }

  return (
    <Container>
      <div>
        <h1 className={"text-3xl sm:text-5xl font-bold mb-10"}>{registration.title}</h1>

        <p className={"text-base sm:text-xl mb-10"}>{registration.text}</p>
      </div>

      <form method="GET" onSubmit={ handleSubmit } action={'/form'} id={'configuration-form'}>
        <div>
          <input 
            type="text"
            id="first_name"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="Förnamn" 
            placeholder="Förnamn"
            pattern="[a-zA-Z0-9]{1,15}" />
        </div>

        <div>
          <input 
            type="text"
            id="last_name"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="Efternamn" 
            placeholder="Efternamn"
            pattern="[a-zA-Z0-9]{1,15}"
            required />
        </div>

        <div>
          <input
            type="text"
            id="tel"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="tel"
            placeholder="Telefon"
            required />
        </div>

        <div>
          <input
            type="text"
            id="org"
            className={'h-8 mb-4 pl-4 text-lg'}
            name="org"
            placeholder="Org. nr."
            required />
        </div>

        <div>
          <input 
            // pattern="/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
            id="mail"
            className={'h-8 mb-4 pl-4 text-lg'}
            size="30"
            placeholder="E-post" 
            required />
        </div>

        { state.error === true ?
          <div className={"error"}>
            Något gick fel med din beställning.
          </div>: null }
        
        <div className={"flex justify-end mt-6"}>
          <input
            type="submit"
            value="Skicka förfrågan"
            className="px-8 py-3 bg-green text-2xl text-white font-medium rounded-tl-3xl rounded-br-3xl font-bold cursor-pointer" />
        </div>
      </form>



    </Container>
  );
};

export default RegisterView;
